module.exports = __webpack_public_path__ + "static/media/Pesos.df161614.svg";